import { render, staticRenderFns } from "./P2POffersAndDeals.vue?vue&type=template&id=6b3addde&"
import script from "./P2POffersAndDeals.vue?vue&type=script&lang=js&"
export * from "./P2POffersAndDeals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports